module.exports = __webpack_public_path__ + "static/media/1.9048a5a1.png";